import React, { useMemo } from 'react';
import { SlidersHorizontal } from 'lucide-react';

import StatusCard from './StatusCard';
import { useDashboardStore } from '../../../stores/dashboard-store';
import { ToggleSwitch } from '../../../components/dashboard/ToggleSwitch';
import { useLanguage } from '../../../contexts/LanguageContext';
// import CountryFilter from '../../../components/filters/CountryFilter';
import { 
  OutstandingIcon, 
  PaymentVerifiedIcon, 
  PendingItemCompletionIcon, 
  PaymentUnverifiedIcon, 
  ForProcurementIcon, 
  CheckmarkIcon
} from '../../../components/icons/DashboardIcons';

const OrderProcessingStatus: React.FC = () => {
  const { stats, filters, updateFilters } = useDashboardStore();
  const { t } = useLanguage();

  // Remove the fetchStats call from individual components
  // The main dashboard page handles fetching stats

  const statusCards = useMemo(() => [
    // First row - 3 cards
    {
      title: t('dashboard.outstanding'),
      value: (stats?.status_counts?.outstanding || 0).toString(),
      change: '+20%',
      changeType: 'increase' as const,
      icon: OutstandingIcon,
      color: 'purple',
      navigateTo: '/orders?tab=outstanding'
    },
    {
      title: t('dashboard.paymentVerified'),
      value: (stats?.status_counts?.['payment-verified'] || 0).toString(),
      change: '+30%',
      changeType: 'increase' as const,
      icon: PaymentVerifiedIcon,
      color: 'purple',
      navigateTo: '/orders?tab=payment_verified'
    },
    {
      title: t('dashboard.pendingItemCompletion'),
      value: (stats?.status_counts?.['pending-item-completion'] || 0).toString(),
      change: '+1%',
      changeType: 'increase' as const,
      icon: PendingItemCompletionIcon,
      color: 'red',
      navigateTo: '/orders?tab=pending_item_completion'
    },
    // Second row - 3 cards
    {
      title: t('dashboard.paymentUnverified'),
      value: (stats?.status_counts?.['item-completion-payment-unverified'] || 0).toString(),
      change: '+12%',
      changeType: 'increase' as const,
      icon: PaymentUnverifiedIcon,
      color: 'orange',
      navigateTo: '/orders?tab=item_completion_unverified'
    },
    {
      title: t('dashboard.paymentVerified'),
      value: (stats?.status_counts?.['item-completion-payment-verified'] || 0).toString(),
      change: '+10%',
      changeType: 'increase' as const,
      icon: CheckmarkIcon,
      color: 'green',
      navigateTo: '/orders?tab=item_completion_payment_verified'
    },
    {
      title: t('dashboard.forProcurement'),
      value: (stats?.status_counts?.['prepare-for-procurement'] || 0).toString(),
      change: '+30%',
      changeType: 'increase' as const,
      icon: ForProcurementIcon,
      color: 'blue',
      navigateTo: '/orders?tab=ready_for_procurement'
    }
  ], [stats, t]);

  const handleIncludeTestOrdersChange = (checked: boolean) => {
    updateFilters({ includeTestOrder: checked });
  };

  // const handleCountrySelect = (countryCode: string) => {
  //   // Convert country code to marketplace code
  //   const marketplaceCode = (() => {
  //     switch (countryCode) {
  //       case 'UK': return 'uk_mkt';
  //       case 'US': return 'us_mkt';
  //       case 'EU': return 'eu_mkt';
  //       case 'TR': return 'tr_mkt';
  //       case 'GF': return 'gf_mkt';
  //       default: return countryCode;
  //     }
  //   })();
    
  //   // Toggle the marketplace in the filter
  //   const currentFilter = filters.marketplaceFilter;
  //   const newFilter = currentFilter.includes(marketplaceCode)
  //     ? currentFilter.filter(code => code !== marketplaceCode)
  //     : [...currentFilter, marketplaceCode];
    
  //   updateFilters({ marketplaceFilter: newFilter });
  // };

  return (
    <div className="rounded-lg bg-[#F1F1F4] p-3 md:p-4">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="text-[35px] font-medium leading-none text-[#24304F]">{t('dashboard.orderProcessingStatus')}</h2>
        <div className="flex items-center space-x-4">
          <button className="inline-flex items-center gap-1.5 rounded-md bg-[#DFE3EC] px-3 py-1.5 text-[13px] font-medium text-[#5D6680]">
            <SlidersHorizontal size={14} />
            {t('common.week')}
          </button>
          <div className="flex items-center space-x-2">
            <ToggleSwitch
              label={t('dashboard.includeTestOrders')}
              checked={filters.includeTestOrder}
              onChange={handleIncludeTestOrdersChange}
            />
          </div>
        </div>
      </div>

     

      <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3">
        {statusCards.map((card, index) => (
          <StatusCard
            key={index}
            card={card}
          />
        ))}
      </div>
    </div>
  );
};

export default OrderProcessingStatus;